export default {
    "": "TbestPro",
    "ganico": "Ganico",
    "tbestproGlobal": "TBestPro Global",
}
